module.exports = __webpack_public_path__ + "static/media/freeongkir.5161d9f6.png";